export default "__VITE_ASSET__CykQQDft__"